import styled, { StyledProps } from 'styled-components/macro';

export type SwitchStylesProps = StyledProps<{
  isActive: boolean;
}>;

export const Switch = styled.div<SwitchStylesProps>`
  width: 20px;
  height: 10px;
  background: ${props => props.isActive ? '#00BF3F' : '#FA8938'};
  border-radius: 25px;
  position: relative;
  cursor: pointer;

  &:before {
    content: "";
    width: 6px;
    height: 6px;
    background: #fff;
    position: absolute;
    border-radius: 50%;
    top: 2px;
    right: ${props => props.isActive ? 'auto' : '2px'};
    left: ${props => props.isActive ? '2px' : 'auto'};
    transition: .2s;
  }
`;
